export const defaultNumberProducts = 30;
